import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CustomerPortalRetailPriceSaveFieldsFragment = { __typename?: 'CustomerPortalRetailPriceSave', jobId: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null };

export type CustomerPortalRetailPriceRowResultFieldsFragment = { __typename?: 'CustomerPortalRetailPriceRowResult', rowIndex: number, itemId: string, action: Types.CustomerPortalRetailPriceAction, status: Types.CustomerPortalRetailPriceRowStatus, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }>, customerRetailPrice?: { __typename?: 'CustomerRetailPrice', itemId: string, baselineToken: string, current?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, last?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, promo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, afterPromo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, scheduledStanding?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null } | null };

export type GetCustomerPortalRetailPriceSaveQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  jobId: Types.Scalars['String']['input'];
}>;


export type GetCustomerPortalRetailPriceSaveQuery = { __typename?: 'Query', customerPortalRetailPriceSave?: { __typename?: 'CustomerPortalRetailPriceSave', jobId: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null } | null };

export type GetCustomerPortalRetailPriceSaveRowsQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  jobId: Types.Scalars['String']['input'];
  skip: Types.Scalars['Int']['input'];
  take: Types.Scalars['Int']['input'];
}>;


export type GetCustomerPortalRetailPriceSaveRowsQuery = { __typename?: 'Query', customerPortalRetailPriceSave?: { __typename?: 'CustomerPortalRetailPriceSave', jobId: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null, rows: Array<{ __typename?: 'CustomerPortalRetailPriceRowResult', rowIndex: number, itemId: string, action: Types.CustomerPortalRetailPriceAction, status: Types.CustomerPortalRetailPriceRowStatus, errors: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }>, customerRetailPrice?: { __typename?: 'CustomerRetailPrice', itemId: string, baselineToken: string, current?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, last?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, promo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, afterPromo?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null, scheduledStanding?: { __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null } | null } | null }> } | null };

export type GetCustomerPortalRetailPriceHistoryQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  itemId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCustomerPortalRetailPriceHistoryQuery = { __typename?: 'Query', customerPortalRetailPriceHistory?: { __typename?: 'CustomerPortalRetailPriceHistoryConnection', totalCount: number, nodes?: Array<{ __typename?: 'CustomerRetailPriceRecord', customerItemId: string, price?: number | null, currency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, fromDate?: string | null, throughDate?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const CustomerPortalRetailPriceSaveFieldsFragmentDoc = new TypedDocumentString(`
    fragment CustomerPortalRetailPriceSaveFields on CustomerPortalRetailPriceSave {
  jobId
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
}
    `, {"fragmentName":"CustomerPortalRetailPriceSaveFields"});
export const CustomerPortalRetailPriceRowResultFieldsFragmentDoc = new TypedDocumentString(`
    fragment CustomerPortalRetailPriceRowResultFields on CustomerPortalRetailPriceRowResult {
  rowIndex
  itemId
  action
  status
  errors {
    code
    message
  }
  customerRetailPrice {
    ...CustomerRetailPriceFields
  }
}
    fragment CustomerRetailPriceFields on CustomerRetailPrice {
  itemId
  current {
    ...CustomerRetailPriceRecordFields
  }
  last {
    ...CustomerRetailPriceRecordFields
  }
  promo {
    ...CustomerRetailPriceRecordFields
  }
  afterPromo {
    ...CustomerRetailPriceRecordFields
  }
  scheduledStanding {
    ...CustomerRetailPriceRecordFields
  }
  baselineToken
}
fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}`, {"fragmentName":"CustomerPortalRetailPriceRowResultFields"});
export const GetCustomerPortalRetailPriceSaveDocument = new TypedDocumentString(`
    query GetCustomerPortalRetailPriceSave($tenantId: String!, $jobId: String!) {
  customerPortalRetailPriceSave(tenantId: $tenantId, jobId: $jobId) {
    ...CustomerPortalRetailPriceSaveFields
  }
}
    fragment CustomerPortalRetailPriceSaveFields on CustomerPortalRetailPriceSave {
  jobId
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
}`);
export const GetCustomerPortalRetailPriceSaveRowsDocument = new TypedDocumentString(`
    query GetCustomerPortalRetailPriceSaveRows($tenantId: String!, $jobId: String!, $skip: Int!, $take: Int!) {
  customerPortalRetailPriceSave(tenantId: $tenantId, jobId: $jobId) {
    ...CustomerPortalRetailPriceSaveFields
    rows(skip: $skip, take: $take) {
      ...CustomerPortalRetailPriceRowResultFields
    }
  }
}
    fragment CustomerPortalRetailPriceSaveFields on CustomerPortalRetailPriceSave {
  jobId
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
}
fragment CustomerPortalRetailPriceRowResultFields on CustomerPortalRetailPriceRowResult {
  rowIndex
  itemId
  action
  status
  errors {
    code
    message
  }
  customerRetailPrice {
    ...CustomerRetailPriceFields
  }
}
fragment CustomerRetailPriceFields on CustomerRetailPrice {
  itemId
  current {
    ...CustomerRetailPriceRecordFields
  }
  last {
    ...CustomerRetailPriceRecordFields
  }
  promo {
    ...CustomerRetailPriceRecordFields
  }
  afterPromo {
    ...CustomerRetailPriceRecordFields
  }
  scheduledStanding {
    ...CustomerRetailPriceRecordFields
  }
  baselineToken
}
fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}`);
export const GetCustomerPortalRetailPriceHistoryDocument = new TypedDocumentString(`
    query GetCustomerPortalRetailPriceHistory($tenantId: String!, $itemId: String!, $first: Int, $after: String) {
  customerPortalRetailPriceHistory(
    tenantId: $tenantId
    itemId: $itemId
    first: $first
    after: $after
  ) {
    nodes {
      ...CustomerRetailPriceRecordFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CustomerRetailPriceRecordFields on CustomerRetailPriceRecord {
  customerItemId
  price
  currency
  effectiveFrom
  effectiveUntil
  fromDate
  throughDate
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerPortalRetailPriceSave: build.query<GetCustomerPortalRetailPriceSaveQuery, GetCustomerPortalRetailPriceSaveQueryVariables>({
      query: (variables) => ({ document: GetCustomerPortalRetailPriceSaveDocument, variables })
    }),
    GetCustomerPortalRetailPriceSaveRows: build.query<GetCustomerPortalRetailPriceSaveRowsQuery, GetCustomerPortalRetailPriceSaveRowsQueryVariables>({
      query: (variables) => ({ document: GetCustomerPortalRetailPriceSaveRowsDocument, variables })
    }),
    GetCustomerPortalRetailPriceHistory: build.query<GetCustomerPortalRetailPriceHistoryQuery, GetCustomerPortalRetailPriceHistoryQueryVariables>({
      query: (variables) => ({ document: GetCustomerPortalRetailPriceHistoryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerPortalRetailPriceSaveQuery, useLazyGetCustomerPortalRetailPriceSaveQuery, useGetCustomerPortalRetailPriceSaveRowsQuery, useLazyGetCustomerPortalRetailPriceSaveRowsQuery, useGetCustomerPortalRetailPriceHistoryQuery, useLazyGetCustomerPortalRetailPriceHistoryQuery } = injectedRtkApi;
